import { AddCartMethod } from "modules/cart/types/add-cart-methods";
import { filterParam } from "../../catalog/types/filters_params";


//const HOST = process.env.NODE_ENV === "production"? process.env.REACT_APP_CARRY_BACKEND_PRD_URL:process.env.REACT_APP_CARRY_BACKEND_URL;
const HOSTVAR = process.env.REACT_APP_CARRY_BACKEND_URL;
const STREAMHOST = process.env.REACT_APP_CARRY_BACKEND_STREAM_URL;

const API_PREFIX = "/api"
const HOST = `${HOSTVAR}${API_PREFIX}`;
// console.log("HOST",HOST);
export const endPointMenu = `${HOST}/sections`;


export const endPointStoreData = `${HOST}/stores`

export const endPointCatalog = (section: string, page: string, sort_by: string, filters: Array<filterParam>) => {
    const url = new URL(`${HOST}/sections/${section}`);
    if (page) url.searchParams.append("page", page);
    url.searchParams.append("sort", sort_by);
    filters.forEach((filter) => {
        filter.value.forEach(value => {
            url.searchParams.append(filter.name, value);
        });
    });
    return url.href;
}

export const endPointProduct = (id: string) => `${HOST}/product/${id}`;

export const endPointProductAlternatives = (sku: string, cached: boolean = true) =>
    `${HOST}/product/${sku}/alternatives?cached=${cached}`;

export const endPointCatalogSearch = (words: string, page: string | null, sort_by: string, filters: Array<filterParam>, prevpage?: string | null) => {
    const url = new URL(`${HOST}/search/${words}`);
    if (page) url.searchParams.append("page", page);
    if (prevpage) url.searchParams.append("prevpage", prevpage);
    url.searchParams.append("sort", sort_by);
    filters.forEach((filter) => {
        filter.value.forEach(value => {
            url.searchParams.append(filter.name, value);
        });
    });
    return url.href;
}

export const getPriceEndpoint = (sku: string, qty: number, method: AddCartMethod) => {
    return `${HOST}/product/${sku}/price?qty=${qty}&method=${method}`;
}

export const getEPProductUpdates = (sku: string) => {
    return `${HOST}/product_upd/${sku}`;
}


export const endPointCatalogFilters = (section: string, searchMode: boolean) => {
    if (!searchMode) return `${HOST}/sections/${section}/filters`;
    return `${HOST}/search/${section}/filters`;
}

export const endPointOptimized = () => `${HOST}/checkout`;
export const endPointCheckStatus = (taskId:string) =>  (`${HOST}/check_status?order_id=${taskId}`);
export const endPointRecalcOptimizedResults = (orderId: number) => `${HOST}/checkout/${orderId}`;
export const endPointOptimizedResults = (orderId:number, scenarioId?:number, storeId?:number) =>  {
    let url = `${HOST}/results?order_id=${orderId}`;
    if (scenarioId !== undefined) {
        url += `&scenario_id=${scenarioId}`;
    }
    if (storeId !== undefined) {
        url += `&store_id=${storeId}`;
    }
    return url;
};

export const endPointExampleResults = `${HOST}/landing_example_results`;

export const endPointGetDifferencesCheckOut = () => `${HOST}/check_updates`;


export const cancelEndpoint = (id:number) => {
    return `${HOST}/cancel/${id}/`
}

export const confirmEndpoint = (id:number) => {
    return `${HOST}/confirm/${id}/`
}

export const endpointExtPendingOrder =  `${HOST}/ext_pendings/`;



export const endPointSearch = (words:string) => {return  `${HOST}/search_predictive/${words}`;}

export const adminFix = (productID:string) => {return  `${HOST}/join/${productID}`;}

export const endPointlogin = `${HOST}/login`;
export const endPointCheckLogin = `${HOST}/isAuth`;
export const endPointRefreshToken = `${HOST}/refresh-token`;
export const endPointLogout = `${HOST}/logout`;
export const endPointPasswordRestore = `${HOST}/request_password_reset`;
export const endPointValidateToken = `${HOST}/validate_reset_token`;
export const endPointPasswordReset = `${HOST}/reset_password_confirm`;

export const endPointCreateAccount = `${HOST}/create_account`;
export const endPointConfirmAccount = `${HOST}/confirm_account`;
export const endPointResendAccountCode = `${HOST}/resend_account_code`;
export const endPointVerifyAccountToken = `${HOST}/verify_account_token`;

export const savePreferencesEndPoint = `${HOST}/save_preferences`;

export const updateLocationEndPoint = `${HOST}/update_location`;


export const updateAccountEndPoint = `${HOST}/update_account`;
export const userFcmTokenEndPoint = `${HOST}/users/fcm-token`;

/**
 * Persists the completed onboarding draft (cut-1 subset) for the
 * authenticated user. Invoked from `usePersistOnboardingData` when the user
 * reaches `/store`. Backend cut 2 must treat duplicate payloads idempotently.
 */
export const endPointUserOnboarding = `${HOST}/users/onboarding`;

export const endPointUserData = `${HOST}/users/user_data`;

/**
 * Read-only subscription settings for the authenticated user.
 * Consumed by the `/settings/subscription` screen.
 */
export const endPointSubscriptionSettings = `${HOST}/users/subscription-settings`;

export const settingsLocationEndPoint = `${HOST}/settings/locations`;

export const dashboardEndPoint = `${HOST}/user/dashboard`;

export const lastOrdersEndPoint = `${HOST}/last_orders`;


export const highDifferenceEndPoint = (section:string) =>  (`${HOST}/high_differences/${section}`);

export const suggestionsEndPoint = (orderId:number) =>  (`${HOST}/suggestions?order_id=${orderId}`);

export const storePreferencesEndPoint = (isLogged:boolean, location_id:number) =>  isLogged ? `${HOST}/settings/store_preferences` : `${HOST}/settings/store_preferences_public?location=${location_id}`;

export const settingsSuscriptionsEndPoint = `${HOST}/settings/suscriptions`;


/**
 * Backend bulk product-update trigger path. Location context travels in the
 * request body (`{ location_id, items: [...] }`), not in the query string.
 * @returns Absolute URL for `POST /api/product_upd/bulk`.
 */
export const endPointBulkCartUpdate = () =>  (`${HOST}/product_upd/bulk`);

// Lists
export const endPointLists = `${HOST}/lists`;
export const endPointListDetail = (listId: string) => `${HOST}/lists/${listId}`;
export const endPointListSeedTemplate = (listId: string) =>
    `${HOST}/lists/${listId}/seed-template`;
export const endPointListItems = (listId: string) => `${HOST}/lists/${listId}/items`;
export const endPointListItemSearch = (q: string, skipParse?: boolean) => {
    const base = `${HOST}/lists/search-item?q=${encodeURIComponent(q)}`;
    return skipParse ? `${base}&skip_parse=true` : base;
};
export const endPointListItem = (listId: string, itemId: string) =>
    `${HOST}/lists/${listId}/items/${itemId}`;
export const endPointListItemsReorder = (listId: string) =>
    `${HOST}/lists/${listId}/items/reorder`;
export const endPointListsReorder = `${HOST}/lists/reorder`;
export const endPointListExecute = (listId: string) =>
    `${HOST}/lists/${listId}/execute`;
export const endPointListExecuteStream = (listId: string) =>
    `${HOST}/lists/${listId}/execute/stream`;
export const endPointListMigrateStream = (listId: string) =>
    `${HOST}/lists/${listId}/migrate/stream`;
export const endPointListExecution = (executionId: string) =>
    `${HOST}/list_executions/${executionId}`;
export const endPointListCandidateSelect = (executionId: string, listItemId: string) =>
    `${HOST}/list_executions/${executionId}/items/${listItemId}/candidate`;


export const cartCreation = `${HOST}/carts_create`;
export const cartCreationResume = `${HOST}/carts_create_resume`;
export const cartCreationStream = `${HOST}/carts_create/status`;
export const cartCreationHealth = `${HOST}/carts_create/health`;
export const cartCreationExtendStreaming = `${HOST}/carts_create/extend_streaming`;
export const addReplacedItems = `${HOST}/add_replaced_items/`;
export const endPointCartMigrate = `${HOST}/cart/migrate-to-uuid`;

export const selectCheckoutScenarioEndpoint = (orderId: number) => `${HOST}/checkout/scenarios/${orderId}/selected`;

/**
 * Builds the authenticated endpoint used to validate connected store sessions
 * before navigating to cart creation for a checkout scenario.
 */
export const scenarioStoreSessionsEndpoint = (scenarioId: number) => `${HOST}/checkout/scenarios/${scenarioId}/store-sessions`;

/**
 * Builds the PATCH endpoint to persist an unavailable-product replacement
 * for a given checkout scenario.
 * @param scenarioId The scenario (order) ID from OptimizedScenario.order_id.
 * @returns Absolute URL for `PATCH /api/checkout/scenarios/{scenario_id}/unavailable-replacement`.
 */
export const unavailableReplacementEndpoint = (scenarioId: number) =>
  `${HOST}/checkout/scenarios/${scenarioId}/unavailable-replacement`;

/**
 * Builds the authenticated endpoint that issues a fresh remote-browser token
 * for account linking before cart creation starts.
 * @param storeId Target store identifier that the orchestrator token must bind to.
 * @returns Absolute URL for `GET /api/account-linking/screencast-token`.
 */
export const accountLinkingScreencastTokenEndpoint = (storeId: number) => `${HOST}/account-linking/screencast-token?store_id=${storeId}`;

export const getMissedItemsEndpoint = (skus: string[]) => {
    const params = new URLSearchParams();
    skus.forEach(id => params.append('missed_products', id));
    return `${HOST}/get_missed_products/?${params.toString()}`;
}

export const remoteBrowserEndpoint = (token:string,store_id:number, isMobile:boolean, resume:boolean) => {

    return `${STREAMHOST}?token=${token}&store_id=${store_id}${isMobile?'&is_mobile=true':''}&resume=${resume}`;
};

export const remoteBrowserUiEventsEndpoint = (token:string,store_id:number, isMobile:boolean) => {
    return `${STREAMHOST}?token=${token}&store_id=${store_id}${isMobile?'&is_mobile=true':''}&channel=ui`;
};
export const refreshScreenCastToken = (store_id:number) => `${HOST}/refresh_screencast_token?store_id=${store_id}`;

// Chat endpoints

export const chatEndpoint = `${HOST}/chat`;
export const chatStreamEndpoint = `${HOST}/chat/stream`;
export const chatAnswerEndpoint = `${HOST}/chat/answer`;


// Subscription
export const endPointSubscriptionCreate = `${HOST}/subscription/create`;
export const endPointSubscriptionPreview = `${HOST}/subscription/preview`;
export const endPointSubscriptionStatus = `${HOST}/subscription-status`;
export const endPointCheckBenefit = `${HOST}/subscription/check-benefit`;

/**
 * Deferred cancellation endpoint: `POST /api/subscription/cancel`.
 * Requires a valid session; rejects corporate / non-cancellable plans.
 */
export const endPointSubscriptionCancel = `${HOST}/subscription/cancel`;

export type {filterParam};
